<style></style>

<template>
    <div>
        <program-progress 
            :program="program"
            :assessments="assessments"
            :modules="modules"
            class="mb-4"
            :survey-cutoffs="surveyCutoffs"
        ></program-progress>
        
        <h2 class="lighter">My Activities</h2>
        <how-to-row>
            <template #left>
                <how-to-video></how-to-video>
            </template>
            <template #right>
                <print-dropdown icon="icon-book">
                    <template #trigger-label>
                            View the How-To Guide
                    </template>
                    <template #collapse-content>
                        <ul class="list-unstyled">
                            <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Full.pdf'" target="_blank">English Desktop</a></li>
                            <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Full_Spanish.pdf'" target="_blank">Español Desktop</a></li>
                            <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Full_Mobile.pdf'" target="_blank">English Mobile</a></li>
                            <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Full_Mobile Spanish.pdf'" target="_blank">Español Mobile</a></li>
                        </ul>
                    </template>
                </print-dropdown>
            </template>
        </how-to-row>
        <div class="assessments-dash-component">
            <dashboard-tabs :program="program" :modules="modules" :assessments="assessments">
                <template #primary="{ module }">
                    <assessment-actions :module="module" :assessments="assessmentsInModule(module)"></assessment-actions>
                </template>
                
                <template #secondary="{ module }">
                    <div :class="'border-'+ module.color" class="mx-0 p-4 border-top-0">
                        <span class="five-steps-number two float-left"></span>
                        <h3 class="lighter text-orange mb-0">
                            Plan
                        </h3>
                        <action-plan-list :module="module" :action-plans="plansInModule(module.id)" :assessments="assessmentsInModule(module)"></action-plan-list>
                    </div>

                    <div :class="'border-'+ module.color" class="completed-assessments mx-0 p-4 border-top-0 row">
                        <div class="col-sm-4 step-number">
                            <div class="five-steps-number three float-left"></div>
                            <h3 class="lighter text-orange ml-2" style="white-space: nowrap;">
                                Take Action
                            </h3>
                            <a :href="$basePath+'/tips-and-materials/'" class="btn btn-orange-blue text-white btn-sm w-100">
                                View Tips &amp; Materials
                            </a>
                        </div>
                        <div class="col-sm-4 step-number">
                            <div class="five-steps-number four float-left"></div>
                            <h3 class="lighter text-orange">
                                Learn More
                            </h3>
                            <a :href="$basePath+'/provider-trainings'" class="btn btn-orange-blue text-white btn-sm w-100">
                                View Available Trainings
                            </a>
                        </div>
                        <div class="col-sm-4 step-number">
                            <div class="five-steps-number five float-left"></div>
                            <h3 class="lighter text-orange">
                                Keep It Up
                            </h3>
                            <a :href="$basePath+'/self-assessments/'+module.slug+'/new'" class="btn btn-orange-blue text-white btn-sm w-100">
                                Retake My Assessment
                            </a>
                        </div>
                    </div>

                </template>
            </dashboard-tabs>
        </div>
        
    </div>
</template>

<script>
    import DashboardTabs from '../dashboard_tabs/DashboardTabs'
    import ProgramProgress from './ProgramProgress'
    import HowToVideo from '../HowToVideo'
    import AssessmentActions from '../assessments/AssessmentActions'
    import ActionPlanList from '../action_plans/ActionPlanList'
    import HowToRow from '../HowToRow'
    import PrintDropdown from '../../components/PrintDropdown'


    export default {
        components: {
            DashboardTabs,
            ProgramProgress,
            HowToVideo,
            AssessmentActions,
            ActionPlanList,
            HowToRow,
            PrintDropdown
        },
        props: {
            program: {
                required: true,
                type: Object
            },
            modules: {
                required: true,
                type: Array
            },
            assessments: {
                required: true,
                type: Array
            },
            actionPlans: {
                required: true,
                type: Array
            },
            surveyCutoffs: {
                required: true,
                type: Object
            }
            
        },
        data() {
            return {
                showModal: false
            }
        },
        methods: {
            plansInModule(moduleId) {
                return (this.actionPlans) ? this.actionPlans.filter((ap) => ap.goal.best_practice.module_id == moduleId) : [];
            },
            assessmentsInModule(module) {
                return this.assessments.filter(assessment => assessment.survey.module_id == module.id)
            }
        }
    }
</script>